export { default } from './SamplesView';



// WEBPACK FOOTER //
// ./src/components/views/SamplesView/index.js